import { language } from 'js/locale/constants'

export const GetCleanedPaths = (keepPages, url) => {
  let paths = (url && url.split('/')) || document.location.pathname.split('/')
  let i = paths.length

  // Remove unwanted parts of the paths
  while (i--) {
    // Empty strings
    if (paths[i] === '') {
      paths.splice(i, 1)
    } else {
      // Language slugs
      for (var lang in language) {
        if (Object.prototype.hasOwnProperty.call(language, lang)) {
          if (paths[i] === language[lang]) {
            paths.splice(i, 1)
          }
        }
      }

      // Pagination
      if (!keepPages) {
        if (paths[i] === 'page') {
          // First remove `page`
          paths.splice(i, 1)
          // Then the page number
          paths.splice(i, 1)
        }
      }
    }
  }

  return paths
}
